import { render, staticRenderFns } from "./points_task_pointLockAuth.vue?vue&type=template&id=775ab33b&scoped=true"
import script from "./points_task_pointLockAuth.vue?vue&type=script&lang=js"
export * from "./points_task_pointLockAuth.vue?vue&type=script&lang=js"
import style0 from "./points_task_pointLockAuth.vue?vue&type=style&index=0&id=775ab33b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775ab33b",
  null
  
)

export default component.exports